// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"Finish_headerLogo__1l_lQ","buttonArea":"Finish_buttonArea__1vySe","body":"Finish_body__1Xyv8","text":"Finish_text__1isXU","note":"Finish_note__23gfP"};